import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class NetworkPointDetailsOperatorInfoTargetCapacityCategoryComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public loggedInUser: any;
    public networkPoint: NetworkPointDto;
    public incrementalTargetCapacityTypeExpanded: boolean = true;
    public accessPointConfiguration: NetworkPointConfigurationDto;
    public possibleTargetCapacityCategoriesForIncremental: string[];
    public uiLoadingIncrementalTargetCategories: boolean = true;
    public canEditAccessPointSettings: boolean = false;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private NetworkPoint: NetworkPointResource,
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private $q: ng.IQService,
        public DATES
    ) {}

    $onInit(): void {
        if (!this.isCreateMode) {
            this.canEditAccessPointSettings =
                !this.networkPoint.bundled &&
                this.loggedInUser.role === 'TSO_USER' &&
                this.loggedInUser.referenceId === this.networkPoint.tso0Id;

            if (this.canEditAccessPointSettings) {
                this.loadIncrementalTargetCategoriesSettings();
            } else {
                this.uiLoadingIncrementalTargetCategories = false;
            }
        }
    }

    private loadIncrementalTargetCategoriesSettings(): void {
        let configPromise = this.NetworkPoint.getConfiguration(
            { id: this.networkPoint.id0 },
            (result: NetworkPointConfigurationDto) => {
                this.accessPointConfiguration = result;
            }
        ).$promise;
        let targetPromise =
            this.NetworkPoint.possibleTargetCapacityCategoriesForIncremental(
                { id: this.networkPoint.id0 },
                (result: string[]) => {
                    this.possibleTargetCapacityCategoriesForIncremental =
                        result;
                }
            ).$promise;
        this.$q.all([configPromise, targetPromise]).then(() => {
            this.uiLoadingIncrementalTargetCategories = false;
        });
    }

    private saveIncrementalTargetCategoriesSetting(): void {
        this.NetworkPoint.saveTargetCapacityCategoryForIncremental(
            { id: this.networkPoint.id0 },
            this.accessPointConfiguration.incrementalTargetCapacityCategory,
            (result: NetworkPointConfigurationDto) => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            }
        ).$promise.catch(this.errorHandler);
    }
}

angular
    .module('app')
    .component('pkpNetworkPointDetailsOperatorInfoTargetCapacityCategory', {
        controller:
            NetworkPointDetailsOperatorInfoTargetCapacityCategoryComponentCtrl,
        template:
            require('app/network-point/network-point-details-operator-info-target-capacity-category.component.html'),
        bindings: {
            form: '=',
            networkPoint: '=',
            isEditMode: '<',
            isCreateMode: '<',
            loggedInUser: '<'
        }
    });
